<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-if="permission.inspectplan_add"
          @click="openInspectplanAddDialog"
          >新 增
        </el-button>
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.inspectplan_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          v-if="permission.inspectplan_view"
          @click="openInspectplanViewDialog(scope.row)"
          >查看
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          v-if="permission.inspectplan_edit"
          @click="openInspectplanEditDialog(scope.row)"
          >修改
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-delete"
          v-if="permission.inspectplan_delete"
          @click="rowDel(scope.row)"
          >删除
        </el-button>
      </template>
      <template slot="nodeId" slot-scope="{ row }">
        <el-tag>{{ nodeIdList(row, row.nodeId) }}</el-tag>
      </template>
    </avue-crud>
    <el-drawer
      title="新增"
      :visible.sync="openInspectplanAddDialogFlag"
      :modal-append-to-body="false"
      @close="quitInspectplanAddDialog"
      size="70%"
    >
      <div class="el-dialog-div">
        <avue-form
          ref="inspectplanAddFormRef"
          v-model="inspectplanAddForm"
          :option="inspectplanAddOption"
          @submit="inspectplanAddSubmit"
        >
          <template slot="crud1" slot-scope="scope">
            <avue-crud :data="data1Copy" :option="option2" @selection-change="selectionChangeItem">
              <template slot="menuLeft">
                <el-input
                  v-model="inspectContent"
                  @input="inspectContentFilter()"
                  placeholder="模糊匹配巡检内容"
                >
                </el-input>
              </template>
            </avue-crud>
          </template>
          <template slot="crud1Label" slot-scope="row">
            <span><span style="color: red;">*&nbsp;</span>巡检项:&nbsp;&nbsp;</span>
          </template>
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitInspectplanAddDialog">返回</el-button>
          </template>
          <template slot="time" slot-scope="row">
            <select-time
              v-show="inspectplanAddForm.groupId"
              :selectedTime="selectedTime"
              @getTime="getTime"
              ref="selectTimeAdd"
            >
            </select-time>
          </template>
          <template slot="timeLabel">
            <el-tooltip
              content="请先选择班组后再选择时间段"
              placement="right"
              effect="dark"
              :value="showTooltip"
              :manual="true"
            >
              <span><span style="color: red;">*&nbsp;</span>时间段&nbsp;&nbsp;</span>
            </el-tooltip>
          </template>

          <template slot-scope="scope" slot="areaId">
            <div>
              <el-select
                @change="selectBasePropertyChange"
                v-model="inspectplanAddForm.areaId"
                clearable
              >
                <el-option
                  v-for="item in basePropertyList"
                  :key="item.id"
                  :label="item.objectFullName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </template>
          <template slot-scope="scope" slot="groupId">
            <div>
              <el-select
                v-model="inspectplanAddForm.groupId"
                clearable
                filterable
                @change="(value) => selectGroup(value, 1)"
              >
                <el-option
                  v-for="item in inspectGroupList"
                  :key="item.id"
                  :label="item.groupName"
                  :value="item.id"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.rightValue"
                    placement="left"
                  >
                    <span style="float: left;">{{ item.groupName }}</span>
                  </el-tooltip>
                </el-option>
              </el-select>
            </div>
          </template>
          <template slot-scope="scope" slot="nodeId">
            <div>
              <el-select
                ref="nodeFormRef"
                v-model="inspectplanAddForm.nodeId"
                @change="selectInspectNodeChange"
                clearable
                filterable
                multiple
              >
                <el-option
                  v-for="item in inspectNodeList"
                  :key="item.id"
                  :label="item.nodeName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </template>
        </avue-form>
      </div>
    </el-drawer>
    <el-drawer
      title="修改"
      size="70%"
      :visible.sync="openInspectplanEditDialogFlag"
      :modal-append-to-body="false"
      @close="quitInspectplanEditDialog"
    >
      <div class="el-dialog-div">
        <avue-form
          ref="inspectplanEditFormRef"
          v-model="inspectplanEditForm"
          :option="inspectplanEditOption"
          @submit="inspectplanEditSubmit"
        >
          <template slot="crud1" slot-scope="scope">
            <avue-crud
              :data="data1Copy"
              :option="option2"
              ref="crud1"
              @selection-change="selectionChangeItem"
            >
              <template slot="menuLeft">
                <el-input
                  v-model="inspectContent"
                  @input="inspectContentFilter()"
                  placeholder="模糊匹配巡检内容"
                >
                </el-input>
              </template>
            </avue-crud>
          </template>
          <template slot="crud1Label" slot-scope="row">
            <span><span style="color: red;">*&nbsp;</span>巡检项:&nbsp;&nbsp;</span>
          </template>
          <template slot="time" slot-scope="row">
            <select-time
              @getTime="getTimeUpdate"
              :selectedTime="selectedTime"
              ref="selectTimeUpdate"
              :groupId="inspectplanEditForm.groupId"
              :quantumTime="row.value"
            >
            </select-time>
          </template>
          <template slot="timeLabel">
            <span><span style="color: red;">*&nbsp;</span>时间段&nbsp;&nbsp;</span>
          </template>

          <template slot-scope="scope" slot="areaId">
            <div>
              <el-select
                @change="selectBasePropertyChange"
                v-model="inspectplanEditForm.areaId"
                clearable
              >
                <el-option
                  v-for="item in basePropertyList"
                  :key="item.id"
                  :label="item.objectFullName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </template>
          <template slot-scope="scope" slot="groupId">
            <div>
              <el-select
                v-model="inspectplanEditForm.groupId"
                @change="(value) => selectGroup(value, 2)"
                clearable
                filterable
              >
                <el-option
                  v-for="item in inspectGroupList"
                  :key="item.id"
                  :label="item.groupName"
                  :value="item.id"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.rightValue"
                    placement="top-start"
                  >
                    <span style="float: left;">{{ item.groupName }}</span>
                  </el-tooltip>
                </el-option>
              </el-select>
            </div>
          </template>
          <template slot-scope="scope" slot="nodeId">
            <div>
              <el-select
                v-model="inspectplanEditForm.nodeId"
                @change="selectInspectNodeChange"
                clearable
                filterable
                multiple
              >
                <el-option
                  v-for="item in inspectNodeList"
                  :key="item.id"
                  :label="item.nodeName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </template>
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitInspectplanEditDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-drawer>
    <el-drawer
      size="70%"
      title="查看"
      :visible.sync="openInspectplanViewDialogFlag"
      :modal-append-to-body="false"
      @close="quitInspectplanViewDialog"
    >
      <div class="el-dialog-div">
        <avue-form
          ref="inspectplanViewFormRef"
          v-model="inspectplanViewForm"
          :option="inspectplanViewOption"
        >
          <template slot="crud1" slot-scope="scope">
            <avue-crud
              ref="crud2"
              :data="data1"
              :option="optionView"
              @selection-change="selectionChangeItem"
            >
            </avue-crud>
          </template>
          <template slot="time" slot-scope="row">
            <select-time
              ref="selectTime"
              :selectedTime="selectedTime"
              :disabled="true"
              :quantumTime="row.value"
            >
            </select-time>
          </template>
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitInspectplanViewDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-drawer>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getInspectProject,
  getBasePropertyTree,
} from '@/api/v4ward/inspectplan/inspectplan';
import { mapGetters } from 'vuex';
import inspectplanAddOption from './inspectplan-add-option';
import inspectplanEditOption from './inspectplan-edit-option';
import inspectplanViewOption from './inspectplan-view-option';
import { getInspectPlanAndProjectList } from '../../../api/v4ward/inspectplanandproject/inspectplanandproject';
import { getInspectGroupTree } from '../../../api/v4ward/inspectgroup/inspectgroup';
import { getInspectNodeTree } from '../../../api/v4ward/inspectnode/inspectnode';
import selectTime from '@/components/inspect/select-time.vue';
import { selectInspectTime } from '@/api/v4ward/inspecttask/inspecttask';

export default {
  components: {
    'select-time': selectTime,
  },
  data() {
    return {
      showTooltip: true, //时间段选择时提示框
      selectedTime: '', //巡检班组其他巡检计划已选时间段
      nodeList: [],
      basePropertyList: [],
      inspectNodeList: [],
      inspectGroupList: [],
      list: [],
      inspectplanId: '',
      inspectplanAddOption: inspectplanAddOption,
      inspectplanEditOption: inspectplanEditOption,
      inspectplanViewOption: inspectplanViewOption,
      openInspectplanViewDialogFlag: false,
      openInspectplanEditDialogFlag: false,
      openInspectplanAddDialogFlag: false,
      inspectplanAddForm: {},
      inspectplanEditForm: {},
      inspectplanViewForm: {},
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        selection: true,
        columnBtn: false,
        searchLabelWidth: 100,
        refreshBtn: false,
        labelWidth: 120,
        column: [
          {
            label: '主键',
            prop: 'id',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
          },
          {
            label: '计划名称',
            prop: 'planName',
            search: true,
            minWidth: 100,
            align: 'center',
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
            searchPlaceholder: '模糊匹配计划名称',
          },
          {
            label: '巡检点名称',
            minWidth: 100,
            prop: 'nodeId',
            type: 'tree',
            slot: true,
            dicUrl: 'api/inspectNode/inspectNodeTree',
            props: { label: 'nodeName', value: 'id' },
            overHidden: true,
          },
          {
            label: '班组名称',
            prop: 'groupId',
            type: 'tree',
            overHidden: true,
            minWidth: 100,
            dicUrl: 'api/inspectGroup/inspectGroupTree',
            props: { label: 'groupName', value: 'id' },
          },
          {
            label: '班组名称',
            prop: 'groupName',
            hide: true,
            search: true,
            maxlength: 30,
            showWordLimit: true,
            searchPlaceholder: '模糊匹配班组名称',
          },
          {
            label: '班组负责人',
            prop: 'groupPrincipalId',
            search: true,
            type: 'tree',
            align: 'center',
            minWidth: 150,

            dicUrl: 'api/blade-user/userTree',
            props: { label: 'realName', value: 'id' },
            rules: [
              {
                required: true,
                message: '请选择班组负责人',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '计划开始时间',
            prop: 'planBeginTime',
            type: 'datetime',
            dataType: 'sting',
            align: 'center',
            minWidth: 110,
            format: 'yyyy-MM-dd ',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '计划结束时间',
            align: 'center',
            minWidth: 110,
            type: 'datetime',
            format: 'yyyy-MM-dd ',
            valueFormat: 'yyyy-MM-dd ',
            prop: 'planEndTime',
          },
          {
            label: '巡检周期',
            prop: 'inspectCycleType',
            type: 'select',
            dataType: 'number',
            align: 'center',
            minWidth: 80,
            dicUrl: 'api/blade-system/dict/dictionary?code=inspect_cycle_type',
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: '时间段',
            align: 'center',
            minWidth: 200,
            overHidden: true,
            prop: 'timeQuantum',
          },
          {
            label: '巡视开始时间',
            prop: 'inspectBeginTime',
            type: 'datetime',
            dataType: 'sting',
            align: 'center',
            minWidth: 110,
            format: 'yyyy-MM-dd ',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },

          {
            label: '具体时间',
            align: 'center',
            minWidth: 110,
            overHidden: true,
            prop: 'detailTime',
          },
          {
            label: '周期休息天数（天）',
            align: 'center',
            minWidth: 150,
            prop: 'intervalTime',
          },

          {
            label: '允许逾期',
            align: 'center',
            minWidth: 80,
            prop: 'staleDatedStatus',
            type: 'radio',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=stale_dated_status',
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: '逾期时间(分钟)',
            align: 'center',
            minWidth: 120,
            prop: 'beyondTheTime',
            type: 'number',
            display: false,
          },
          {
            label: '计划开始时间',
            prop: 'planBeginTimeRange',
            searchSpan: 6,
            search: true,
            searchRange: true,
            hide: true,
            type: 'daterange',
            display: false,
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '计划结束时间',
            prop: 'planEndTimeRange',
            searchSpan: 6,
            search: true,
            searchRange: true,
            hide: true,
            type: 'daterange',
            display: false,
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
        ],
      },
      data: [],
      data1: [],
      data1Copy: [],
      data2: [],
      inspectContent: '',
      option2: {
        page: false,
        border: true,
        addBtn: false,
        selection: true,
        tip: false,
        columnBtn: false,
        refreshBtn: false,
        menuAlign: 'center',
        menu: false,
        column: [
          {
            label: 'ID',
            prop: 'nodeId',
            hide: true,
          },
          {
            label: '巡检点名称',
            prop: 'nodeName',
          },
          {
            label: '巡检点id',
            prop: 'projectId',
            hide: true,
          },
          {
            label: '巡检内容',
            prop: 'inspectContent',
          },
        ],
      },
      optionView: {
        page: false,
        border: true,
        addBtn: false,
        selection: false,
        tip: false,
        columnBtn: false,
        refreshBtn: false,
        menuAlign: 'center',
        menu: false,
        column: [
          {
            label: '巡检点名称',
            prop: 'nodeId',
            type: 'tree',
            dataType: 'string',
            dicUrl: 'api/inspectNode/inspectNodeTree',
            props: { label: 'nodeName', value: 'id' },
            overHidden: true,
          },
          {
            label: '巡检内容',
            prop: 'inspectContent',
          },
        ],
      },
    };
  },
  created() {
    //加载列表
    getInspectNodeTree().then(({ data }) => {
      this.nodeList = data;
    });
  },
  mounted() {
    this.initAllList();
  },
  watch: {
    'inspectplanAddForm.inspectCycleType'() {
      if (this.inspectplanAddForm.inspectCycleType === 1) {
        this.findObject(
          this.inspectplanAddOption.group[1].column,
          'detailTimeWeek'
        ).display = false;
        this.findObject(
          this.inspectplanAddOption.group[1].column,
          'detailTimeMonth'
        ).display = false;
        this.findObject(
          this.inspectplanAddOption.group[1].column,
          'inspectBeginTime'
        ).display = false;
        this.findObject(this.inspectplanAddOption.group[1].column, 'num').display = false;
        this.findObject(this.inspectplanAddOption.group[1].column, 'intervalTime').display = false;
      }
      if (this.inspectplanAddForm.inspectCycleType === 2) {
        this.findObject(this.inspectplanAddOption.group[1].column, 'detailTimeWeek').display = true;
        this.findObject(
          this.inspectplanAddOption.group[1].column,
          'detailTimeMonth'
        ).display = false;
        this.findObject(
          this.inspectplanAddOption.group[1].column,
          'inspectBeginTime'
        ).display = false;
        this.findObject(this.inspectplanAddOption.group[1].column, 'num').display = false;
        this.findObject(this.inspectplanAddOption.group[1].column, 'intervalTime').display = false;
      }
      if (this.inspectplanAddForm.inspectCycleType === 3) {
        this.findObject(
          this.inspectplanAddOption.group[1].column,
          'detailTimeWeek'
        ).display = false;
        this.findObject(
          this.inspectplanAddOption.group[1].column,
          'detailTimeMonth'
        ).display = true;
        this.findObject(
          this.inspectplanAddOption.group[1].column,
          'inspectBeginTime'
        ).display = false;
        this.findObject(this.inspectplanAddOption.group[1].column, 'num').display = false;
        this.findObject(this.inspectplanAddOption.group[1].column, 'intervalTime').display = false;
      }
      if (this.inspectplanAddForm.inspectCycleType === 4) {
        this.findObject(
          this.inspectplanAddOption.group[1].column,
          'detailTimeWeek'
        ).display = false;
        this.findObject(
          this.inspectplanAddOption.group[1].column,
          'detailTimeMonth'
        ).display = false;
        this.findObject(
          this.inspectplanAddOption.group[1].column,
          'inspectBeginTime'
        ).display = true;
        this.findObject(this.inspectplanAddOption.group[1].column, 'num').display = true;
        this.findObject(this.inspectplanAddOption.group[1].column, 'intervalTime').display = true;
      }
    },
    'inspectplanEditForm.inspectCycleType'() {
      if (this.inspectplanEditForm.inspectCycleType === 1) {
        this.findObject(
          this.inspectplanEditOption.group[1].column,
          'detailTimeWeek'
        ).display = false;
        this.findObject(
          this.inspectplanEditOption.group[1].column,
          'detailTimeMonth'
        ).display = false;
        this.findObject(
          this.inspectplanEditOption.group[1].column,
          'inspectBeginTime'
        ).display = false;
        this.findObject(this.inspectplanEditOption.group[1].column, 'num').display = false;
        this.findObject(this.inspectplanEditOption.group[1].column, 'intervalTime').display = false;
      }
      if (this.inspectplanEditForm.inspectCycleType === 2) {
        this.findObject(
          this.inspectplanEditOption.group[1].column,
          'detailTimeWeek'
        ).display = true;
        this.findObject(
          this.inspectplanEditOption.group[1].column,
          'detailTimeMonth'
        ).display = false;
        this.findObject(
          this.inspectplanEditOption.group[1].column,
          'inspectBeginTime'
        ).display = false;
        this.findObject(this.inspectplanEditOption.group[1].column, 'num').display = false;
        this.findObject(this.inspectplanEditOption.group[1].column, 'intervalTime').display = false;
      }
      if (this.inspectplanEditForm.inspectCycleType === 3) {
        this.findObject(
          this.inspectplanEditOption.group[1].column,
          'detailTimeWeek'
        ).display = false;
        this.findObject(
          this.inspectplanEditOption.group[1].column,
          'detailTimeMonth'
        ).display = true;
        this.findObject(
          this.inspectplanEditOption.group[1].column,
          'inspectBeginTime'
        ).display = false;
        this.findObject(this.inspectplanEditOption.group[1].column, 'num').display = false;
        this.findObject(this.inspectplanEditOption.group[1].column, 'intervalTime').display = false;
      }
      if (this.inspectplanEditForm.inspectCycleType === 4) {
        this.findObject(
          this.inspectplanEditOption.group[1].column,
          'detailTimeWeek'
        ).display = false;
        this.findObject(
          this.inspectplanEditOption.group[1].column,
          'detailTimeMonth'
        ).display = false;
        this.findObject(
          this.inspectplanEditOption.group[1].column,
          'inspectBeginTime'
        ).display = true;
        this.findObject(this.inspectplanEditOption.group[1].column, 'num').display = true;
        this.findObject(this.inspectplanEditOption.group[1].column, 'intervalTime').display = true;
      }
    },
    'inspectplanViewForm.inspectCycleType'() {
      if (this.inspectplanViewForm.inspectCycleType === 1) {
        this.findObject(
          this.inspectplanViewOption.group[1].column,
          'detailTimeWeek'
        ).display = false;
        this.findObject(
          this.inspectplanViewOption.group[1].column,
          'detailTimeMonth'
        ).display = false;
        this.findObject(
          this.inspectplanViewOption.group[1].column,
          'inspectBeginTime'
        ).display = false;
        this.findObject(this.inspectplanViewOption.group[1].column, 'num').display = false;
        this.findObject(this.inspectplanViewOption.group[1].column, 'intervalTime').display = false;
      }
      if (this.inspectplanViewForm.inspectCycleType === 2) {
        this.findObject(
          this.inspectplanViewOption.group[1].column,
          'detailTimeWeek'
        ).display = true;
        this.findObject(
          this.inspectplanViewOption.group[1].column,
          'detailTimeMonth'
        ).display = false;
        this.findObject(
          this.inspectplanViewOption.group[1].column,
          'inspectBeginTime'
        ).display = false;
        this.findObject(this.inspectplanViewOption.group[1].column, 'num').display = false;
        this.findObject(this.inspectplanViewOption.group[1].column, 'intervalTime').display = false;
      }
      if (this.inspectplanViewForm.inspectCycleType === 3) {
        this.findObject(
          this.inspectplanViewOption.group[1].column,
          'detailTimeWeek'
        ).display = false;
        this.findObject(
          this.inspectplanViewOption.group[1].column,
          'detailTimeMonth'
        ).display = true;
        this.findObject(
          this.inspectplanViewOption.group[1].column,
          'inspectBeginTime'
        ).display = false;
        this.findObject(this.inspectplanViewOption.group[1].column, 'num').display = false;
        this.findObject(this.inspectplanViewOption.group[1].column, 'intervalTime').display = false;
      }
      if (this.inspectplanViewForm.inspectCycleType === 4) {
        this.findObject(
          this.inspectplanViewOption.group[1].column,
          'detailTimeWeek'
        ).display = false;
        this.findObject(
          this.inspectplanViewOption.group[1].column,
          'detailTimeMonth'
        ).display = false;
        this.findObject(
          this.inspectplanViewOption.group[1].column,
          'inspectBeginTime'
        ).display = true;
        this.findObject(this.inspectplanViewOption.group[1].column, 'num').display = true;
        this.findObject(this.inspectplanViewOption.group[1].column, 'intervalTime').display = true;
      }
    },
    'inspectplanAddForm.staleDatedStatus'() {
      if (this.inspectplanAddForm.staleDatedStatus === 0) {
        this.findObject(this.inspectplanAddOption.group[1].column, 'beyondTheTime').display = true;
      }
      if (this.inspectplanAddForm.staleDatedStatus === 1) {
        this.findObject(this.inspectplanAddOption.group[1].column, 'beyondTheTime').display = false;
      }
    },
    'inspectplanEditForm.staleDatedStatus'() {
      if (this.inspectplanEditForm.staleDatedStatus === 0) {
        this.findObject(this.inspectplanEditOption.group[1].column, 'beyondTheTime').display = true;
      }
      if (this.inspectplanEditForm.staleDatedStatus === 1) {
        this.findObject(
          this.inspectplanEditOption.group[1].column,
          'beyondTheTime'
        ).display = false;
      }
    },
    'inspectplanViewForm.staleDatedStatus'() {
      if (this.inspectplanViewForm.staleDatedStatus === 0) {
        this.findObject(this.inspectplanViewOption.group[1].column, 'beyondTheTime').display = true;
      }
      if (this.inspectplanViewForm.staleDatedStatus === 1) {
        this.findObject(
          this.inspectplanViewOption.group[1].column,
          'beyondTheTime'
        ).display = false;
      }
    },
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.inspectplan_add, false),
        viewBtn: this.vaildData(this.permission.inspectplan_view, false),
        delBtn: this.vaildData(this.permission.inspectplan_delete, false),
        editBtn: this.vaildData(this.permission.inspectplan_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    nodeIdList(row, id) {
      let nodeName = [];
      let list = [];
      list = id.split(',');
      list.forEach((s) => {
        this.nodeList.forEach((data) => {
          if (s === data.id) {
            nodeName.push(data.nodeName);
            return;
          }
        });
      });
      return nodeName.join('，');
    },
    selectInspectNodeChange(value) {
      this.data1Copy = [];
      if (value) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        getInspectProject(value.join(',')).then(({ data }) => {
          this.data1 = data;
          this.data1Copy = data;
          loading.close();
        });
      }
    },
    selectBasePropertyChange(value) {
      getInspectGroupTree(value).then(({ data }) => {
        this.inspectGroupList = data;
      });
      getInspectNodeTree(value).then(({ data }) => {
        this.inspectNodeList = data;
      });
    },
    // 班组选择时返回该班组已存在的计划所选时间段
    selectGroup(value, type) {
      if (type == 1) {
        this.showTooltip = false;
        this.$refs.selectTimeAdd.reset();
      } else if (type == 2) {
        this.$refs.selectTimeUpdate.reset();
      }
      selectInspectTime(value).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          for (let j = i; j < res.data.length; j++) {
            if (res.data[i].beginTime > res.data[j].beginTime) {
              [res.data[i], res.data[j]] = [res.data[j], res.data[i]];
            }
          }
        }
        this.selectedTime = res.data;
      });
    },
    // 获得时间选择器传来的值
    getTime(time) {
      this.inspectplanAddForm.timeQuantum = time;
    },
    getTimeUpdate(time) {
      this.inspectplanEditForm.timeQuantum = time;
    },
    initAllList() {
      getInspectGroupTree().then(({ data }) => {
        this.inspectGroupList = data;
      });
      getInspectNodeTree().then(({ data }) => {
        this.inspectNodeList = data;
      });
      getBasePropertyTree().then(({ data }) => {
        this.basePropertyList = data;
      });
    },
    inspectContentFilter() {
      let inspectContent = this.inspectContent;
      if (inspectContent) {
        this.data1Copy = this.data1.filter(function (item) {
          return item.inspectContent.indexOf(inspectContent) > -1;
        });
      } else {
        this.data1Copy = this.data1;
      }
    },
    selectionChangeItem(list) {
      this.data2 = list;
    },
    quitInspectplanAddDialog() {
      this.showTooltip = false;
      this.findObject(this.inspectplanAddOption.group[1].column, 'detailTimeWeek').display = false;
      this.findObject(this.inspectplanAddOption.group[1].column, 'detailTimeMonth').display = false;
      this.findObject(
        this.inspectplanAddOption.group[1].column,
        'inspectBeginTime'
      ).display = false;
      this.findObject(this.inspectplanAddOption.group[1].column, 'num').display = false;
      this.findObject(this.inspectplanAddOption.group[1].column, 'intervalTime').display = false;
      this.findObject(this.inspectplanAddOption.group[1].column, 'beyondTheTime').display = false;
      this.openInspectplanAddDialogFlag = false;
      this.$refs.inspectplanAddFormRef.resetForm();
      this.inspectplanAddForm.nodeId = [];
      this.data1 = [];
      this.data2 = [];
      this.$refs['nodeFormRef'].resetFields();
      this.initAllList();
      this.inspectplanAddForm.time = [];
    },
    quitInspectplanViewDialog() {
      this.findObject(this.inspectplanViewOption.group[1].column, 'detailTimeWeek').display = false;
      this.findObject(
        this.inspectplanViewOption.group[1].column,
        'detailTimeMonth'
      ).display = false;
      this.findObject(
        this.inspectplanViewOption.group[1].column,
        'inspectBeginTime'
      ).display = false;
      this.findObject(this.inspectplanViewOption.group[1].column, 'num').display = false;
      this.findObject(this.inspectplanViewOption.group[1].column, 'intervalTime').display = false;
      this.findObject(this.inspectplanViewOption.group[1].column, 'beyondTheTime').display = false;
      this.openInspectplanViewDialogFlag = false;
      this.$refs.inspectplanViewFormRef.resetForm();
      this.inspectplanViewForm.time = [];
      this.data1 = [];
      this.data2 = [];
    },
    openInspectplanViewDialog(row) {
      let timeRange = [];
      timeRange.push(row.planBeginTime);
      timeRange.push(row.planEndTime);
      this.inspectplanViewForm.planTimeRange = timeRange;
      this.inspectplanViewForm.areaId = row.areaId;
      this.inspectplanViewForm.planName = row.planName;
      this.inspectplanViewForm.nodeId = row.nodeId;
      this.inspectplanViewForm.groupId = row.groupId;
      this.inspectplanViewForm.planBeginTime = row.planBeginTime;
      this.inspectplanViewForm.planEndTime = row.planEndTime;
      this.inspectplanViewForm.inspectCycleType = row.inspectCycleType;
      this.inspectplanViewForm.inspectBeginTime = row.inspectBeginTime;
      this.inspectplanViewForm.intervalTime = row.intervalTime;
      this.inspectplanViewForm.staleDatedStatus = row.staleDatedStatus;
      this.inspectplanViewForm.beyondTheTime = row.beyondTheTime;
      if (row.inspectCycleType === 4) {
        this.inspectplanViewForm.num = row.inspectCycle;
        this.findObject(
          this.inspectplanViewOption.group[1].column,
          'inspectBeginTime'
        ).display = true;
        this.findObject(this.inspectplanViewOption.group[1].column, 'num').display = true;
        this.findObject(this.inspectplanViewOption.group[1].column, 'intervalTime').display = true;
      }
      if (row.inspectCycleType === 2) {
        this.inspectplanViewForm.detailTimeWeek = row.detailTime.split(',');
      }
      if (row.inspectCycleType === 3) {
        this.inspectplanViewForm.detailTimeMonth = row.detailTime.split(',');
      }
      let list = [];
      row.timeQuantum.split(',').forEach((s) => {
        let timeList = {};
        timeList.start = s.split('~')[0];
        timeList.end = s.split('~')[1];
        list.push(timeList);
      });
      this.inspectplanViewForm.time = list;
      this.openInspectplanViewDialogFlag = true;
      getInspectPlanAndProjectList(Object.assign({ inspectPlanId: row.id })).then(({ data }) => {
        this.data1 = data;
      });
    },
    inspectplanEditSubmit(from, done) {
      if (this.inspectplanEditForm.inspectBeginTime) {
        let timeBegin = new Date(this.inspectplanEditForm.planTimeRange[0]);
        let timeEnd = new Date(this.inspectplanEditForm.planTimeRange[1]);
        let inspectBeginTime = new Date(this.inspectplanEditForm.inspectBeginTime);
        if (inspectBeginTime < timeBegin) {
          this.$message.error('巡视开始时间要在计划日期范围内');
          done();
          return;
        }
        if (inspectBeginTime > timeEnd) {
          this.$message.error('巡视开始时间要在计划日期范围内');
          done();
          return;
        }
      }
      this.$refs.selectTimeUpdate.byValue();
      if (this.data2.length === 0) {
        this.$message.error('请配置巡检项');
        done();
        return;
      }
      //校验每个巡检点必须勾选一个巡检项

      var nodeIds = this.inspectplanEditForm.nodeId;
      let a = '';
      this.data2.forEach((val) => {
        a += val.nodeId + ',';
      });
      let b = '';
      for (let i = 0; i < nodeIds.length; i++) {
        if (a.indexOf(nodeIds[i]) > -1) {
          b += '0';
        } else {
          b += '1';
        }
      }
      if (b.indexOf('1') > -1) {
        this.$message.error('每个巡检点请至少选择一个巡检项');
        done();
        return;
      }

      from.id = this.inspectplanId;
      let time = [];
      this.inspectplanEditForm.timeQuantum.forEach((s) => {
        time.push(s.time);
      });
      from.timeQuantum = time.join(',');
      if (from.inspectCycleType === 1) {
        from.inspectCycle = 1;
      }
      if (from.inspectCycleType === 2) {
        from.inspectCycle = 7;
        from.detailTime = from.detailTimeWeek.join(',');
      }
      if (from.inspectCycleType === 3) {
        from.inspectCycle = 31;
        from.detailTime = from.detailTimeMonth.join(',');
      }
      if (from.inspectCycleType === 4) {
        from.inspectCycle = from.num;
      }
      from.inspectPlanAndProjectList = this.data2;
      from.planBeginTime = from.planTimeRange[0];
      from.planEndTime = from.planTimeRange[1];
      from.nodeId = from.nodeId.join(',');
      update(from).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.quitInspectplanEditDialog();
          done();
        },
        (error) => {
          done();
        }
      );
    },
    quitInspectplanEditDialog() {
      this.findObject(this.inspectplanEditOption.group[1].column, 'detailTimeWeek').display = false;
      this.findObject(
        this.inspectplanEditOption.group[1].column,
        'detailTimeMonth'
      ).display = false;
      this.findObject(
        this.inspectplanEditOption.group[1].column,
        'inspectBeginTime'
      ).display = false;
      this.findObject(this.inspectplanEditOption.group[1].column, 'num').display = false;
      this.findObject(this.inspectplanEditOption.group[1].column, 'intervalTime').display = false;
      this.findObject(this.inspectplanEditOption.group[1].column, 'beyondTheTime').display = false;
      this.openInspectplanEditDialogFlag = false;
      this.$refs.inspectplanEditFormRef.resetForm();
      this.inspectplanEditForm.nodeId = [];
      this.initAllList();
      this.data1 = [];
      this.data2 = [];
    },
    openInspectplanEditDialog(row) {
      getInspectProject(row.nodeId).then(({ data }) => {
        this.data1 = data;
        this.data1Copy = data;
        // loading.close();
      });
      selectInspectTime(row.groupId).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          for (let j = i; j < res.data.length; j++) {
            if (res.data[i].beginTime > res.data[j].beginTime) {
              [res.data[i], res.data[j]] = [res.data[j], res.data[i]];
            }
          }
        }
        this.selectedTime = res.data;
      });
      let timeRange = [];
      timeRange.push(row.planBeginTime);
      timeRange.push(row.planEndTime);
      this.inspectplanEditForm.planTimeRange = timeRange;
      this.inspectplanId = row.id;
      this.inspectplanEditForm.areaId = row.areaId;
      this.inspectplanEditForm.planName = row.planName;
      this.inspectplanEditForm.nodeId = row.nodeId.split(',');
      this.inspectplanEditForm.groupId = row.groupId;
      this.inspectplanEditForm.inspectCycleType = row.inspectCycleType;
      this.inspectplanEditForm.inspectBeginTime = row.inspectBeginTime;
      this.inspectplanEditForm.intervalTime = row.intervalTime;
      this.inspectplanEditForm.staleDatedStatus = row.staleDatedStatus;
      this.inspectplanEditForm.beyondTheTime = row.beyondTheTime;
      if (row.inspectCycleType === 4) {
        this.inspectplanEditForm.num = row.inspectCycle;
        this.findObject(
          this.inspectplanEditOption.group[1].column,
          'inspectBeginTime'
        ).display = true;
        this.findObject(this.inspectplanEditOption.group[1].column, 'num').display = true;
        this.findObject(this.inspectplanEditOption.group[1].column, 'intervalTime').display = true;
      }
      if (row.inspectCycleType === 2) {
        this.inspectplanEditForm.detailTimeWeek = row.detailTime.split(',');
      }
      if (row.inspectCycleType === 3) {
        this.inspectplanEditForm.detailTimeMonth = row.detailTime.split(',');
      }
      let list = [];
      row.timeQuantum.split(',').forEach((s) => {
        let timeList = {};
        timeList.start = s.split('~')[0];
        timeList.end = s.split('~')[1];
        list.push(timeList);
      });
      this.inspectplanEditForm.time = list;
      this.openInspectplanEditDialogFlag = true;
      let self = this;
      setTimeout(() => {
        getInspectProject(row.nodeId).then(({ data }) => {
          self.data1Copy = data;
          self.$nextTick(() => {
            getInspectPlanAndProjectList(Object.assign({ inspectPlanId: self.inspectplanId })).then(
              ({ data }) => {
                self.list = data;
                self.list.forEach((ele) => {
                  self.data1Copy.forEach((s, index) => {
                    if (s.projectId === ele.projectId && s.nodeId === ele.nodeId) {
                      self.$refs.crud1.toggleSelection([self.data1Copy[index]]);
                      return;
                    }
                  });
                });
              }
            );
          });
        });
      }, 0);
    },
    inspectplanAddSubmit(loading, done) {
      if (this.inspectplanAddForm.inspectBeginTime) {
        let timeBegin = new Date(this.inspectplanAddForm.planTimeRange[0]);
        let timeEnd = new Date(this.inspectplanAddForm.planTimeRange[1]);
        let inspectBeginTime = new Date(this.inspectplanAddForm.inspectBeginTime);
        if (inspectBeginTime < timeBegin) {
          this.$message.error('巡视开始时间要在计划日期范围内');
          done();
          return;
        }
        if (inspectBeginTime > timeEnd) {
          this.$message.error('巡视开始时间要在计划日期范围内');
          done();
          return;
        }
      }
      if (!this.inspectplanAddForm.timeQuantum) {
        this.$message.error('请选择时间段');
        done();
        return;
      }
      if (this.data2.length === 0) {
        this.$message.error('请配置巡检项');
        done();
        return;
      }
      //校验每个巡检点必须勾选一个巡检项

      var nodeIds = this.inspectplanAddForm.nodeId;
      let a = '';
      this.data2.forEach((val) => {
        a += val.nodeId + ',';
      });
      let b = '';
      for (let i = 0; i < nodeIds.length; i++) {
        if (a.indexOf(nodeIds[i]) > -1) {
          b += '0';
        } else {
          b += '1';
        }
      }
      if (b.indexOf('1') > -1) {
        this.$message.error('每个巡检点请至少选择一个巡检项');
        done();
        return;
      }

      let time = [];
      let addTime = [];
      addTime = this.inspectplanAddForm.timeQuantum;
      addTime.forEach((s) => {
        time.push(s.time);
      });
      this.inspectplanAddForm.timeQuantum = time.join(',');
      if (this.inspectplanAddForm.inspectCycleType === 1) {
        this.inspectplanAddForm.inspectCycle = 1;
      }
      if (this.inspectplanAddForm.inspectCycleType === 2) {
        this.inspectplanAddForm.inspectCycle = 7;
        this.inspectplanAddForm.detailTime = this.inspectplanAddForm.detailTimeWeek.join(',');
      }
      if (this.inspectplanAddForm.inspectCycleType === 3) {
        this.inspectplanAddForm.inspectCycle = 31;
        this.inspectplanAddForm.detailTime = this.inspectplanAddForm.detailTimeMonth.join(',');
      }
      if (this.inspectplanAddForm.inspectCycleType === 4) {
        this.inspectplanAddForm.inspectCycle = this.inspectplanAddForm.num;
      }
      this.inspectplanAddForm.inspectPlanAndProjectList = this.data2;
      this.inspectplanAddForm.planBeginTime = this.inspectplanAddForm.planTimeRange[0];
      this.inspectplanAddForm.planEndTime = this.inspectplanAddForm.planTimeRange[1];
      this.inspectplanAddForm.nodeId = this.inspectplanAddForm.nodeId.join(',');
      add(this.inspectplanAddForm).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.quitInspectplanAddDialog();
          done();
        },
        (error) => {
          done();
        }
      );
    },
    openInspectplanAddDialog() {
      this.showTooltip = true;
      this.data1Copy = [];
      this.inspectplanAddForm.staleDatedStatus = 1;
      this.inspectplanAddForm.inspectCycleType = 1;
      this.openInspectplanAddDialogFlag = true;
      setTimeout(() => {
        this.$refs.selectTimeAdd.reset();
      }, 0);
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?删除之后不再生成巡检任务！', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?删除之后不再生成巡检任务！', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if (this.query.planBeginTimeRange) {
        this.query.planBeginTimeStart = this.query.planBeginTimeRange[0];
        this.query.planBeginTimeEnd = this.query.planBeginTimeRange[1];
      }
      if (this.query.planEndTimeRange) {
        this.query.planEndTimeStart = this.query.planEndTimeRange[0];
        this.query.planEndTimeEnd = this.query.planEndTimeRange[1];
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style scoped>
/deep/ .el-drawer__body {
  overflow: scroll !important;
}
</style>
